
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "currentColor"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "g",
                      "children": [
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "currentColor",
                            "d": "M11.152 13.814H1.351C.606 13.814 0 13.21 0 12.47V4.632c0-.74.606-1.344 1.35-1.344h9.802c.745 0 1.351.603 1.351 1.344v7.837c0 .742-.606 1.345-1.35 1.345zm-9.801-9.63c-.248 0-.451.202-.451.448v7.837c0 .247.201.448.45.448h9.802c.248 0 .451-.201.451-.448V4.632c0-.247-.201-.447-.45-.447H1.35z",
                            "transform": "translate(-362 -33) translate(240 27) translate(122 4) translate(0 2)"
                          }
                        },
                        {
                          "tag": "path",
                          "attrsMap": {
                            "fill": "currentColor",
                            "d": "M14.602 12.348c-.317 0-.628-.107-.884-.315l-1.949-1.578c-.092-.074-.151-.183-.164-.3-.012-.12.023-.237.099-.33.157-.191.44-.22.633-.063l1.948 1.577c.184.149.401.128.544.061.076-.037.254-.145.254-.377V6.08c0-.231-.178-.342-.254-.377-.144-.067-.362-.088-.544.061l-1.948 1.578c-.192.156-.477.128-.633-.064-.157-.192-.128-.475.065-.63l1.949-1.578c.425-.345 1-.41 1.5-.176.474.224.768.68.768 1.186v4.943c0 .508-.294.962-.769 1.186-.2.094-.41.139-.615.139zM2.77 6.2c-.376 0-.682-.302-.682-.671 0-.37.305-.671.682-.671.377 0 .683.302.683.671 0 .37-.306.671-.683.671zm0-.895c-.12 0-.219.1-.219.224 0 .123.098.224.22.224.119 0 .218-.1.218-.224 0-.123-.097-.224-.219-.224z",
                            "transform": "translate(-362 -33) translate(240 27) translate(122 4) translate(0 2)"
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  